export type Page = "dashboard" | "searches" | "hot-deals" | "settings" | "lister" | "lister-card" | "lister-review" | "lister-history";
export type Route = { page: Page; sessionId?: string };

// The shop runs on the lister, so the lister is home: a bare "#/" (and anything unrecognised)
// lands there rather than on the eBay-sniper dashboard.
//
// The dashboard, saved searches and hot deals are HIDDEN, not deleted — they are gone from the
// nav (see LINKS in components/Layout.tsx) but still resolve, so an existing bookmark keeps
// working and putting them back is a one-line change. The dashboard needs its own explicit
// "#/dashboard" now that it is no longer the fallback; before this it was reachable only BY
// being the fallback and had no hash of its own.
export function routeFromHash(hash: string): Route {
  const m = hash.match(/^#\/lister\/s\/([A-Za-z0-9_-]+)/);
  if (m) return { page: "lister-review", sessionId: m[1]! };
  if (hash.startsWith("#/lister/card")) return { page: "lister-card" };
  if (hash.startsWith("#/lister/history")) return { page: "lister-history" };
  if (hash.startsWith("#/lister")) return { page: "lister" };
  if (hash.startsWith("#/searches")) return { page: "searches" };
  if (hash.startsWith("#/hot-deals")) return { page: "hot-deals" };
  if (hash.startsWith("#/settings")) return { page: "settings" };
  if (hash.startsWith("#/dashboard")) return { page: "dashboard" };
  return { page: "lister" };
}

export const hashFor = {
  lister: () => "#/lister",
  dashboard: () => "#/dashboard",
  card: () => "#/lister/card",
  review: (id: string) => `#/lister/s/${id}`,
  history: () => "#/lister/history",
};
